import { Link } from "react-router-dom";

export function WikiLiveRail({ quickLinks = [], liveSidebar = {} }) {
  const { news = [] } = liveSidebar;

  return (
    <div className="space-y-4">
      <section className="border border-amber-900/20 bg-zinc-950/50 p-4">
        <h3 data-testid="wiki-home-shortcut-title" className="font-cinzel text-sm uppercase tracking-[0.2em] text-amber-300">Navigation</h3>
        <Link data-testid="wiki-home-shortcut" to="/wiki" className="mt-3 block border border-zinc-800 bg-zinc-950/60 p-3 text-sm text-amber-100 hover:border-amber-700/40 transition-colors">
          Wiki Home
        </Link>
        <p className="mt-2 text-xs text-zinc-500 leading-relaxed">Jump back to the archive hub from any wiki page.</p>
      </section>

      <section className="border border-amber-900/20 bg-zinc-950/50 p-4">
        <h3 className="font-cinzel text-sm uppercase tracking-[0.2em] text-amber-300">Latest News</h3>
        <div className="mt-3 space-y-3">
          {news.length === 0 ? (
            <p className="text-sm text-zinc-500">No patch notes yet.</p>
          ) : news.map((item) => (
            <Link key={item.id} data-testid={`wiki-news-link-${item.id}`} to="/news" className="block border border-zinc-800 bg-zinc-950/60 p-3 hover:border-amber-700/40 transition-colors">
              <div className="text-sm text-zinc-200">{item.title}</div>
              <div className="mt-1 text-[11px] uppercase tracking-[0.2em] text-zinc-500">{item.created_at ? new Date(item.created_at).toLocaleDateString() : "Recent"}</div>
            </Link>
          ))}
        </div>
      </section>

      <section className="border border-amber-900/20 bg-zinc-950/50 p-4">
        <h3 className="font-cinzel text-sm uppercase tracking-[0.2em] text-amber-300">Quick Links</h3>
        <div className="mt-3 space-y-2">
          {quickLinks.length === 0 ? (
            <p className="text-sm text-zinc-500">Add manual quick links from the wiki admin page.</p>
          ) : quickLinks.map((item) => (
            <Link key={item.id || item.href} data-testid={`wiki-quick-link-${item.id || item.label}`} to={item.href} className="block border border-zinc-800 bg-zinc-950/60 px-3 py-2 text-sm text-zinc-200 hover:border-amber-700/40 transition-colors">
              {item.label}
            </Link>
          ))}
        </div>
      </section>
    </div>
  );
}